export default __webpack_public_path__ + "static/media/A0007.ba2c33f5.png";